(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elune-collection"]) return;
  try {
    
(() => {
  const selector = '.elune-collection .elune-sort';
  let typed = '';
  let typedAt = 0;
  const close = (details, restore = false) => {
    details.open = false;
    if (restore) details.querySelector('summary').focus({ preventScroll: true });
  };
  const position = (details) => {
    const rect = details.querySelector('summary').getBoundingClientRect();
    const below = window.innerHeight - rect.bottom - 20;
    const above = rect.top - 20;
    const up = below < Math.min(240, above) && above > below;
    details.dataset.side = up ? 'top' : 'bottom';
    details.querySelector('.elune-sort-panel').style.maxHeight = `${Math.max(88, Math.min(432, up ? above : below))}px`;
  };
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!details.matches?.(selector) || !details.open) return;
    document.querySelectorAll(`${selector}[open]`).forEach(other => { if (other !== details) close(other); });
    position(details);
  }, true);
  document.addEventListener('pointerdown', (event) => {
    document.querySelectorAll(`${selector}[open]`).forEach(details => { if (!details.contains(event.target)) close(details); });
  });
  document.addEventListener('focusout', (event) => {
    const details = event.target.closest?.(selector);
    if (details?.open && event.relatedTarget && !details.contains(event.relatedTarget)) close(details);
  });
  document.addEventListener('keydown', (event) => {
    const details = event.target.closest?.(selector);
    if (!details) return;
    if (event.key === 'Escape' && details.open) { event.preventDefault(); close(details, true); return; }
    const options = [...details.querySelectorAll('.elune-sort-option')];
    const summary = event.target.closest('summary');
    const index = options.indexOf(event.target.closest('.elune-sort-option'));
    let next = -1;
    if (summary && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
      details.open = true;
      position(details);
      next = event.key === 'ArrowDown' ? 0 : options.length - 1;
    } else if (details.open && index >= 0) {
      if (event.key === 'ArrowDown') next = (index + 1) % options.length;
      if (event.key === 'ArrowUp') next = (index + options.length - 1) % options.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = options.length - 1;
      if (event.key.length === 1 && event.key !== ' ' && !event.ctrlKey && !event.altKey && !event.metaKey) {
        typed = Date.now() - typedAt < 650 ? typed + event.key.toLowerCase() : event.key.toLowerCase();
        typedAt = Date.now();
        const find = prefix => options.findIndex((_, offset) => options[(index + offset + 1) % options.length].textContent.trim().toLowerCase().startsWith(prefix));
        let match = find(typed);
        if (match < 0) { typed = event.key.toLowerCase(); match = find(typed); }
        if (match >= 0) next = (index + match + 1) % options.length;
      }
    }
    if (next >= 0 && options[next]) {
      event.preventDefault();
      options[next].focus({ preventScroll: true });
      options[next].scrollIntoView({ block: 'nearest' });
    }
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('.elune-sort-form');
    const option = event.submitter;
    if (!form || option?.name !== 'sort_by') return;
    event.preventDefault();
    if (option.getAttribute('aria-current') === 'true') { close(form.querySelector('details'), true); return; }
    const destination = new URL(window.location.href);
    destination.searchParams.set('sort_by', option.value);
    destination.searchParams.delete('page');
    window.location.assign(destination.toString());
  });
  const reposition = () => document.querySelectorAll(`${selector}[open]`).forEach(position);
  window.addEventListener('resize', reposition, { passive: true });
  document.addEventListener('scroll', event => { if (!event.target.matches?.('.elune-sort-panel')) reposition(); }, { passive: true, capture: true });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elune-footer"]) return;
  try {
    
(() => {
 if (window.eluneFooterResponsiveReady) return;
 window.eluneFooterResponsiveReady = true;
 let grid;
 let compact;
 let focusedFooterTarget;
 const sync = () => {
  if (!grid?.isConnected) return;
  const nextCompact = getComputedStyle(grid).getPropertyValue('--ef-compact').trim() === '1';
  if (nextCompact === compact) return;
  const active = document.activeElement === document.body ? focusedFooterTarget : document.activeElement;
  const footer = grid.closest('.ef-footer');
  const policyGroup = grid.querySelector('.ef-policy-group');
  const bottomPolicies = footer.querySelector('.ef-policy-links');
  compact = nextCompact;
  grid.querySelectorAll('.ef-group').forEach(group => {
   const summary = group.querySelector('summary');
   group.open = !compact;
   summary.tabIndex = compact ? 0 : -1;
   if (compact) summary.removeAttribute('aria-disabled');
   else summary.setAttribute('aria-disabled', 'true');
   if (compact && group.contains(active) && active !== summary) summary.focus({preventScroll:true});
  });
  if (compact && !footer.classList.contains('ef-footer--home-refined') && bottomPolicies.contains(active)) policyGroup.querySelector('summary').focus({preventScroll:true});
  else if (!compact && policyGroup.contains(active)) {
   const href = active.getAttribute('href');
   const link = [...bottomPolicies.querySelectorAll('a')].find(item => item.getAttribute('href') === href) || bottomPolicies.querySelector('a');
   link.focus({preventScroll:true});
  }
 };
 const observer = 'ResizeObserver' in window ? new ResizeObserver(sync) : null;
 const init = () => {
  const current = document.querySelector('.ef-footer .ef-grid');
  if (current === grid) { sync(); return; }
  observer?.disconnect();
  grid = current;
  compact = undefined;
  if (!grid) return;
  sync();
  observer?.observe(grid);
 };
 document.addEventListener('focusin', event => {
  focusedFooterTarget = event.target.closest('.ef-footer') ? event.target : null;
 });
 document.addEventListener('pointerdown', event => {
  if (!event.target.closest('.ef-footer')) focusedFooterTarget = null;
 });
 document.addEventListener('click', event => {
  const summary = event.target.closest('.ef-footer .ef-group>summary');
  if (summary && !compact) event.preventDefault();
 });
 document.addEventListener('keydown', event => {
  if (event.key !== 'Escape' || !compact) return;
  const group = event.target.closest('.ef-footer .ef-group[open]');
  if (!group) return;
  group.open = false;
  group.querySelector('summary').focus({preventScroll:true});
 });
 window.addEventListener('resize', sync, {passive:true});
 document.addEventListener('shopify:section:load', init);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
 else init();
})();

(() => {
 if (window.eluneSocialMotionReady) return;
 window.eluneSocialMotionReady = true;
 const releaseTimers = new WeakMap();
 document.addEventListener('click', event => {
  const social = event.target.closest('.ef-footer .ef-social');
  if (!social || event.detail !== 0 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  clearTimeout(releaseTimers.get(social));
  social.classList.add('is-pressed');
  releaseTimers.set(social, setTimeout(() => {
   social.classList.remove('is-pressed');
   releaseTimers.delete(social);
  }, 120));
 });
})();

(() => {
 if (window.eluneQuantityReady) return;
 window.eluneQuantityReady = true;
 const limits = input => ({ min: Number(input.min || 0), max: input.max ? Number(input.max) : Infinity });
 const sync = () => document.querySelectorAll('[data-quantity-control]').forEach(control => {
  const input = control.querySelector('input');
  const {min,max} = limits(input);
  const value = Number(input.value);
  control.querySelector('[data-quantity-minus]').disabled = value <= min;
  control.querySelector('[data-quantity-plus]').disabled = value >= max;
 });
 document.addEventListener('click', event => {
  const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
  if (!button || button.disabled) return;
  const input = button.closest('[data-quantity-control]').querySelector('input');
  const {min,max} = limits(input);
  const value = Number(input.value);
  const current = Number.isFinite(value) ? Math.round(value) : min;
  input.value = String(Math.max(min, Math.min(max, current + (button.hasAttribute('data-quantity-plus') ? 1 : -1))));
  input.dispatchEvent(new Event('input', {bubbles:true}));
  input.dispatchEvent(new Event('change', {bubbles:true}));
  sync();
 });
 document.addEventListener('input', event => {if(event.target.closest('[data-quantity-control]'))sync();});
 document.addEventListener('change', sync);
 document.addEventListener('shopify:section:load', sync);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync,{once:true});else sync();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elune-header"]) return;
  try {
    



(()=>{if(window.eluneShopNavReady)return;window.eluneShopNavReady=true;document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;document.querySelectorAll('.shop-disclosure[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus()})});document.addEventListener('click',event=>{document.querySelectorAll('.shop-disclosure[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false})});document.addEventListener('focusin',event=>{document.querySelectorAll('.shop-disclosure[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false})});})();
(() => {
 if(window.eluneAccountEntryReady)return;window.eluneAccountEntryReady=true;
 const menus=()=>[...document.querySelectorAll('.account-disclosure,.shop-disclosure,.mobile-menu')];
 document.addEventListener('toggle',event=>{const active=event.target;if(!active.matches?.('.account-disclosure,.shop-disclosure,.mobile-menu')||!active.open)return;menus().forEach(menu=>{if(menu!==active)menu.open=false;});},true);
 document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;menus().filter(menu=>menu.open).forEach(menu=>{menu.open=false;menu.querySelector('summary')?.focus();});});
 document.addEventListener('click',event=>{menus().filter(menu=>menu.open&&!menu.contains(event.target)).forEach(menu=>menu.open=false);});
 document.addEventListener('focusin',event=>{menus().filter(menu=>menu.open&&!menu.contains(event.target)).forEach(menu=>menu.open=false);});
})();

(() => {
  if (window.eluneStickyHeaderReady) return;
  window.eluneStickyHeaderReady = true;
  let header;
  let previousHeight = 0;
  let previousAnnouncementHeight = -1;
  const measure = () => {
    if (!header?.isConnected) return;
    const navHeight = Math.ceil(header.querySelector('.site-head')?.getBoundingClientRect().height || 0);
    const announcementHeight = Math.ceil(header.querySelector('.announce')?.getBoundingClientRect().height || 0);
    if (announcementHeight !== previousAnnouncementHeight) {
      previousAnnouncementHeight = announcementHeight;
      document.documentElement.style.setProperty('--elune-announcement-height', `${announcementHeight}px`);
    }
    if (!navHeight || navHeight === previousHeight) return;
    previousHeight = navHeight;
    document.documentElement.style.setProperty('--elune-nav-height', `${navHeight}px`);
    document.documentElement.style.setProperty('--elune-header-height', `${navHeight}px`);
  };
  const observer = 'ResizeObserver' in window ? new ResizeObserver(measure) : null;
  const init = () => {
    const current = document.querySelector('.elune-header-section');
    if (current === header) { measure(); return; }
    observer?.disconnect();
    header = current;
    previousHeight = 0;
    previousAnnouncementHeight = -1;
    if (!header) return;
    measure();
    observer?.observe(header);
    header.querySelectorAll('.announce,.site-head').forEach(element => observer?.observe(element));
  };
  window.addEventListener('resize', measure, { passive: true });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elune-home"]) return;
  try {
    (() => {
 const init=()=>{
  const button=document.querySelector('[data-home-phone]'),audio=document.querySelector('[data-home-sample]'),status=document.querySelector('[data-home-audio-status]');
  if(!button||!audio||button.dataset.ready)return;
  button.dataset.ready='true';
  const sync=()=>{button.setAttribute('aria-pressed',String(!audio.paused));button.setAttribute('aria-label',audio.paused?'Play sample voice':'Pause sample voice');};
  button.addEventListener('click',async()=>{
   if(!audio.paused){audio.pause();return;}
   try{await audio.play();if(status)status.textContent='Playing the sample recording.';}catch{if(status)status.textContent='The sample could not play. Please try again.';}
  });
  for(const event of ['play','pause','ended'])audio.addEventListener(event,sync);
  audio.addEventListener('ended',()=>{if(status)status.textContent='Sample finished. Tap the phone to replay.';});
  sync();
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elune-language"]) return;
  try {
    const englishForm = document.getElementById('EluneLanguage');if (englishForm) {try {if (!sessionStorage.getItem('elune-english-requested')) {sessionStorage.setItem('elune-english-requested', '1');englishForm.submit();}} catch (error) {}}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
